export default {
  fontFamily: ['Archivo', 'Helvetica', 'sans-serif'].join(','),
  htmlFontSize: 16,
  h1: {
    fontSize: '1.6rem',
    fontWeight: '700',
    paddingBottom: '1rem',
  },
  h2: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
    paddingBottom: '1rem',
  },
  h3: {
    fontSize: '1.25rem',
    lineHeight: '2rem',
    fontWeight: 300,
  },
  h4: {
    fontSize: '1.4rem',
    fontWeight: 700,
    paddingBottom: '1rem',
    paddingTop: '1rem',
  },
  h5: { fontSize: '1.2rem', fontWeight: 500, textTransform: 'none' },
  h6: {
    fontSize: '1.1rem',
    fontWeight: 500,
  },
  subtitle1: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    lineHeight: '1rem',
    textTransform: 'none',
  },
  subtitle2: {},
  body1: {
    fontWeight: 500,
    fontSize: '.9rem',
    lineHeight: '1.25rem',
  },
  body2: {},
  button: {},
  caption: {},
  overline: {},
};
